// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_HIDE_TERMS = "Skryj podm\u00ednky";
export const BZ2_SHOW_COMPLETE_TERMS = "Zobraz cel\u00e9 podm\u00ednky";
export const BZ2_TERMS = "Podm\u00ednky";
export const counter_ENTRIES = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1t\u016f"];
export const counter_RATINGS = ["%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed"];
